const PIN_SVG = `
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 382 491">
        <g>
            <linearGradient id="gradient" gradientUnits="userSpaceOnUse" x1="191.1421" y1="2.0005" x2="191.1421" y2="487.3354">
                <stop offset="0" style="stop-color:[COLOR0]"/>
                <stop offset="1" style="stop-color:[COLOR1]"/>
            </linearGradient>
            <path fill="url(#gradient)" d="M340.544,305.497L340.544,305.497c24.524-31.821,39.121-71.69,39.121-114.973
                C379.666,86.406,295.261,2,191.143,2C87.024,2,2.619,86.406,2.619,190.524c0,43.283,14.597,83.152,39.122,114.973l0,0l0.002,0.002
                c2.424,3.146,4.942,6.213,7.556,9.196l141.844,172.64l141.845-172.639c2.613-2.983,5.132-6.052,7.556-9.196L340.544,305.497z"/>
        </g>
        <g>[ICON]</g>
    </svg>`;

const CIRCLE_SVG = `
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 28 28">
        <g>
            <circle fill="[COLOR0]" cx="14" cy="14" r="13"/>
            <circle fill="#FFFFFF" cx="14" cy="14" r="9"/>
            <circle fill="[COLOR0]" cx="14" cy="14" r="5"/>
        </g>
        <g>[ICON]</g>
    </svg>`;

const DIAMOND_SVG = `
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 30 30">
        <g>
            <rect fill="[COLOR0]" transform="translate(15, 15) rotate(45) translate(-15, -15) " x="5" y="5" width="18" height="18"/>
            <rect fill="#FFFFFF" transform="translate(15, 15) rotate(45) translate(-15, -15) " x="8" y="8" width="12" height="12"/>
            <rect fill="[COLOR0]" transform="translate(15, 15) rotate(45) translate(-15, -15) " x="11" y="11" width="6" height="6"/>
        </g>
    </svg>`;

const CLUSTER_SVG = `
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-120 -120 240 240">
        <defs>
            <g id="segment" transform="rotate(45)">
                <path d="M0 67A67 67 0 0 0 67 0L80 0A80 80 0 0 1 0 80Z" fill-opacity="0.6"/>
                <path d="M0 87A87 87 0 0 0 87 0L100 0A100 100 0 0 1 0 100Z" fill-opacity="0.3"/>
                <path d="M0 107A107 107 0 0 0 107 0L120 0A120 120 0 0 1 0 120Z" fill-opacity="0.1"/>
            </g>
        </defs>
        <g fill="[COLOR0]">
            <circle r="62"/>
            <g transform="rotate(60)">
                <use xlink:href="#segment"/>
            </g>
            <g transform="rotate(180)">
                <use xlink:href="#segment"/>
            </g>
            <g transform="rotate(300)">
                <use xlink:href="#segment"/>
            </g>
        </g>
    </svg>`;

const CAR = `
    <path fill="#FFFFFF" d="M308.372,203.5v-26.176c0,0,0-2.83-1.306-4.245c-1.304-1.414-13.689-12.027-13.689-12.027
        s-1.304-4.245-6.52-6.367c-1.715-1.241-3.429-3.023-3.827-3.446l5.131-0.091c6.519,0,9.779-2.124,9.779-2.124
        c1.955-1.415,1.955-4.952,1.955-7.075c0-2.122-2.194-2.922-3.259-3.537c-1.304-0.708-8.823-1.691-8.823-1.691l-11.061,0.536
        c-4.76-7.464-14.209-21.623-19.885-25.729c-3.912-3.537-8.475-5.66-8.475-5.66l-36.51-3.537h-20.587h-0.274h-20.587l-36.509,3.537
        c0,0-4.564,2.123-8.475,5.66c-5.676,4.106-15.125,18.265-19.885,25.729l-11.061-0.536c0,0-7.519,0.983-8.823,1.691
        c-1.065,0.614-3.26,1.415-3.26,3.537c0,2.123,0,5.66,1.956,7.075c0,0,3.26,2.124,9.779,2.124l5.129,0.091
        c-0.398,0.423-2.112,2.205-3.826,3.446c-5.216,2.122-6.519,6.367-6.519,6.367s-12.388,10.613-13.691,12.027
        c-1.304,1.415-1.304,4.245-1.304,4.245V203.5c0,0-0.652,1.416-0.652,2.83c0,1.415,0,48.816,0.652,54.474
        c0,10.613,4.563,11.318,4.563,11.318h26.729c0,0,2.608-1.413,3.26-3.535c1.304-2.122,1.304-9.198,1.304-9.198l15.646,1.415
        l1.956-2.121l14.342,0.706l2.607,2.829l46.802-0.694l46.803,0.694l2.607-2.829l14.343-0.706l1.956,2.121l15.646-1.415
        c0,0,0,7.076,1.305,9.198c0.65,2.122,3.258,3.535,3.258,3.535h26.729c0,0,4.565-0.705,4.565-11.318
        c0.65-5.658,0.65-53.059,0.65-54.474C309.022,204.916,308.372,203.5,308.372,203.5z M133.785,110.15
        c12.068-2.757,54.591-3.533,57.374-3.571c2.783,0.038,45.305,0.813,57.374,3.571c14.343,14.149,25.184,33.279,25.184,33.279
        s-27.28,4.182-78.131,4.182h-4.289h-0.274h-4.289c-50.851,0-78.13-4.182-78.13-4.182S119.443,124.299,133.785,110.15z
        M242.525,200.671c-5.868,8.489-14.343,9.904-14.343,9.904h-29.989c-5.867,0-5.216-4.953-5.216-4.953v-13.441
        c0-5.659,5.216-6.367,5.216-6.367h41.072c5.215,0,5.215,4.952,5.215,4.952C244.48,198.548,241.874,199.963,242.525,200.671z
        M189.992,180.154c-2.52,0.033-3.754-0.82-3.754-2.943c0-1.415,1.147-2.717,3.754-2.717h2.334c2.608,0,3.755,1.302,3.755,2.717
        c0,2.123-1.235,2.976-3.755,2.943 M137.837,190.766c0,0,0-4.952,5.216-4.952h41.073c0,0,5.216,0.708,5.216,6.367v13.441
        c0,0,0.65,4.953-5.216,4.953h-29.99c0,0-8.475-1.415-14.342-9.904C140.445,199.963,137.837,198.548,137.837,190.766z
        M130.667,199.256c-0.652,0.707-2.608,0.707-2.608,0.707l-33.901-2.122c0,0-3.26-0.708-5.868-3.538
        c-2.608-2.83-3.259-6.367-3.259-9.904c0-2.123,0-4.953,0-6.368c0-2.83,1.956-5.66,4.563-6.366c1.955-1.416,5.867,0,5.867,0
        l18.254,4.951c0,0,5.867,2.83,9.779,7.075c3.912,4.245,7.172,12.026,7.172,12.026S131.318,198.548,130.667,199.256z
        M243.829,248.07c-1.304,0-30.642,2.83-46.288,2.83c-0.65,0-1.955,0-3.259,0c-0.652,0-1.305,0-1.956,0c-0.275,0-0.668,0-1.029,0
        c-0.087,0-0.181,0-0.274,0c-0.362,0-0.754,0-1.03,0c-0.65,0-1.303,0-1.956,0c-1.303,0-2.605,0-3.259,0
        c-15.646,0-44.983-2.83-46.287-2.83c-1.304,0-3.26-0.707-3.26-3.537s2.607-12.026,2.607-12.026s1.304-4.245,4.564-6.368
        c2.608-1.414,5.216-1.414,5.867-1.414h42.754h0.274h42.753c0.652,0,3.259,0,5.867,1.414c3.26,2.123,4.563,6.368,4.563,6.368
        s2.607,9.196,2.607,12.026S245.133,248.07,243.829,248.07z M297.288,184.399c0,3.537-0.651,7.074-3.26,9.904
        s-5.867,3.538-5.867,3.538l-33.901,2.122c0,0-1.956,0-2.608-0.707c-0.65-0.708,0-3.538,0-3.538s3.261-7.782,7.172-12.026
        c3.912-4.245,9.779-7.075,9.779-7.075l18.255-4.951c0,0,3.911-1.416,5.866,0c2.609,0.706,4.564,3.537,4.564,6.366
        C297.288,179.447,297.288,182.276,297.288,184.399z"/>`;

const HANDSHAKE = `
    <polygon fill="#FFFFFF" points="318.286,140.424 265.967,94.833 265.967,121.174 65.417,121.174 65.417,159.674 265.967,159.674 265.967,186.015"/>
    <polygon fill="#FFFFFF" points="65.417,227.758 117.735,273.348 117.735,247.007 318.286,247.007 318.286,208.507 117.735,208.507 117.735,182.167"/>`;

const ONSITE_AGENT = `
    <path fill="#FFFFFF" stroke="#FFFFFF" d="m291,258.93499q0,17.46227 -10.62273,27.58182t-28.25273,10.11955l-127.24909,0q-17.61136,0 -28.25273,-10.11955t-10.62273,-27.58182q0,-7.71545 0.50318,-15.07682t2.03136,-15.87818t3.85773,-15.80364t6.26182,-14.20091t9.02,-11.79682t12.44909,-7.79t16.23227,-2.90727q1.30455,0 6.11273,3.13091t10.84636,6.98864t15.72909,6.98864t19.43773,3.13091t19.43773,-3.13091t15.72909,-6.98864t10.84636,-6.98864t6.11273,-3.13091q8.88955,0 16.23227,2.90727t12.44909,7.79t9.02,11.79682t6.26182,14.20091t3.85773,15.80364t2.03136,15.87818t0.50318,15.07682l0.03727,0zm-46.59091,-130.0259q0,23.14636 -16.38136,39.52773t-39.52773,16.38136t-39.52773,-16.38136t-16.38136,-39.52773t16.38136,-39.52773t39.52773,-16.38136t39.52773,16.38136t16.38136,39.52773z"/>`;

const SCHEDULED_RIDE = `
    <rect fill="#FFFFFF" x="13" y="7" width="2" height="8"/>
    <rect fill="#FFFFFF" x="13" y="13" width="8" height="2"/>`;

const DRIVER = `
    <circle cx="191" cy="200" r="110" stroke="#FFFFFF" stroke-width="35" fill="none"/>
    <circle cx="191" cy="200" r="35" stroke="#FFFFFF" stroke-width="0" fill="#FFFFFF"/>
    <polygon points="196,200 186,200 166,300 216,300" fill="#FFFFFF"/>
    <polygon points="191,210 191,190 291,175 291,225" fill="#FFFFFF"/>
    <polygon points="191,210 191,190 91,175 91,225" fill="#FFFFFF"/>`;

export default {
    main: {
        pin: {
            size: { width: 30, height: 40 },
            svg: PIN_SVG
        },
        circle: {
            size: { width: 28, height: 28 },
            svg: CIRCLE_SVG
        },
        diamond: {
            size: { width: 30, height: 30 },
            svg: DIAMOND_SVG
        },
        cluster: {
            // No size required
            svg: CLUSTER_SVG
        }
    },

    symbol: {
        car: CAR,
        handshake: HANDSHAKE,
        onSiteAgent: ONSITE_AGENT,
        scheduledRide: SCHEDULED_RIDE,
        driver: DRIVER
    }
};
